import React, { useState } from 'react';
import {
  CButton, CCard, CCardBody, CCol, CContainer, CForm, CFormInput,
  CInputGroup, CInputGroupText, CRow, CToaster, CToast, CToastBody
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilLockLocked, cilUser, cilEnvelopeOpen } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axiosInstance'; //

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ fullName: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(0);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/api/Members/Register', formData);
      if (res.status === 200) {
        setToast(
          <CToast title="Success" color="success" className="text-white">
            <CToastBody>Registration Successful! Redirecting to login...</CToastBody>
          </CToast>
        );
        setTimeout(() => navigate('/login'), 2000);
      }
    } catch (err) {
      setToast(
        <CToast color="danger" className="text-white">
          <CToastBody>{err.response?.data?.message || "Registration Failed"}</CToastBody>
        </CToast>
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CToaster push={toast} placement="top-end" />
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={6}>
            <CCard className="mx-4 shadow-lg border-0">
              <CCardBody className="p-4">
                <CForm onSubmit={handleSubmit}>
                  <h1 className="text-primary fw-bold">Create Account</h1>
                  <p className="text-muted">Join our community today</p>
                  
                  <CInputGroup className="mb-3">
                    <CInputGroupText><CIcon icon={cilUser} size="sm" /></CInputGroupText>
                    <CFormInput 
                      name="fullName" 
                      placeholder="Full Name" 
                      onChange={handleChange} 
                      required 
                    />
                  </CInputGroup>

                  <CInputGroup className="mb-3">
                    <CInputGroupText><CIcon icon={cilEnvelopeOpen} size="sm" /></CInputGroupText>
                    <CFormInput 
                      name="email" 
                      type="email" 
                      placeholder="Email Address" 
                      onChange={handleChange} 
                      required 
                    />
                  </CInputGroup>

                  <CInputGroup className="mb-3">
                    <CInputGroupText><CIcon icon={cilLockLocked} size="sm" /></CInputGroupText>
                    <CFormInput 
                      name="password" 
                      type="password" 
                      placeholder="Password" 
                      onChange={handleChange} 
                      required 
                    />
                  </CInputGroup>

                  <div className="d-grid">
                    <CButton color="success" type="submit" className="text-white fw-bold py-2" disabled={loading}>
                      {loading ? 'Creating Account...' : 'Register'}
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Register;